import {
  type PimCautionV1,
  type PimProductV11,
} from '@redteclab/api/clients/bully'

import { TENANT } from '../../../tenant'

import { productAccessorIsPrescriptionProduct } from './productAccessorIsPrescriptionProduct'

export const productAccessorGetCautions = (
  product: PimProductV11,
  tenant: TENANT,
): PimCautionV1[] => {
  const isPrescriptionProduct = productAccessorIsPrescriptionProduct(product)

  if (!isPrescriptionProduct || tenant !== TENANT.COM) {
    return []
  }

  const { cautions } = product

  if (!cautions || cautions.length === 0) {
    return []
  }

  /**
   * filter out cautions with no pictogram_url or laymen_text
   */
  return cautions.filter(
    (caution) => caution.pictogram_url && caution.laymen_text,
  )
}
